const ACTIONS = {
    JOIN:'join',
    JOINED:'joined',
    DISCONNECTED:'disconnected',
    CODE_CHANGE:'code-change',
    SYNC_CODE:'sync_code',
    LEAVE:'leave',
    TOGGLE_PERMISSION: 'toggle_permission',
    PERMISSION_CHANGED: 'permission_changed',
    REQUEST_WRITE_ACCESS: 'request_write_access',
    WRITE_ACCESS_REQUESTED: 'write_access_requested',
    APPROVE_CODE_EDIT: 'approve_code_edit',
    DENY_CODE_EDIT: 'deny_code_edit',
    // File system actions
    FS_SYNC: 'fs_sync',
    FS_CREATE_NODE: 'fs_create_node',
    FS_DELETE_NODE: 'fs_delete_node',
    FS_RENAME_NODE: 'fs_rename_node',
    // Uploads: sends nodes + file contents in one batch so content syncs to all collaborators
    FS_UPLOAD_BATCH: 'fs_upload_batch',
    // Server → admin-only: delivers the secure ownership token for reconnect validation
    ADMIN_TOKEN: 'admin_token',
    // Permission denial feedback to client
    PERMISSION_DENIED: 'permission_denied', 
    // Group Chat
    CHAT_SEND: 'chat_send',
    CHAT_RECEIVE: 'chat_receive',
    // File Lock & Edit Access Request
    FILE_LOCKED: 'file_locked',
    FILE_UNLOCKED: 'file_unlocked',
    REQUEST_EDIT_ACCESS: 'request_edit_access',
    APPROVE_EDIT_ACCESS: 'approve_edit_access',
    REJECT_EDIT_ACCESS: 'reject_edit_access',
    ACTIVE_EDITOR_CHANGED: 'active_editor_changed',
    LOCK_STATUS_UPDATE: 'lock_status_update',
    // Activity Feed
    ACTIVITY_RECEIVE: 'activity_receive',
};

module.exports = ACTIONS;